import { PropType, defineComponent } from 'vue'

import { CsPrimaryButton, MsHeadline } from '@sunrise/components'

import { EstateType } from '../../ts/mapper/decoratedEstateDetailMapper.enum'
import { OfferType } from '../../ts/service/realEstateService.enum'
import { buildResultListUrl } from '../../ts/shared/resultListLink'

import { UnavailableContent } from './MsDetailUnavailable.interface'
import UnavailableSvg from './unavailable.svg?component'

export default defineComponent({
    name: 'MsDetailUnavailable',
    components: { CsPrimaryButton, MsHeadline, UnavailableSvg },
    props: {
        content: Object as PropType<UnavailableContent>,
        offerType: {
            type: String as PropType<OfferType>,
            required: true,
        },
        estateType: {
            type: String as PropType<EstateType>,
            required: true,
        },
    },
    setup(props) {
        const resultListUrl = buildResultListUrl(props.offerType, props.estateType)

        return {
            resultListUrl,
        }
    },
})
